import type { Styles } from '@adornis/ass/style.js';
import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('campus-component-sticky-search-bar')
export class CampusComponentStickySearchBar extends ChemistryLitElement {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host': {
          position: 'sticky',
          top: '0',
          zIndex: '1',
          background: this.colors.neutral.shade(50),
        },
      },
    ];
  }

  override render() {
    return html`
      <cr-flex
        horizontal
        crossaxis-center
        space-between
        padding="xl"
        space="md"
        w100
        wrap
        ${css({
          background: this.colors.neutral.shade(50),
          paddingTop: this.spacing.md,
          paddingBottom: this.spacing.md,
        })}
      >
        <cr-input
          @value-changed=${(e: ValueEvent<string>) =>
            this.dispatchEvent(
              new CustomEvent('search-text-changed', {
                detail: e.detail,
                bubbles: true,
                composed: true,
                cancelable: true,
              }),
            )}
          placeholder="Suchen..."
          icon="search"
          flex
        ></cr-input>
      </cr-flex>
    `;
  }
}
